<template>
    <n-dialog v-model:visible="visible" :fullscreen="false">
        <div class="universal-content" :class="{'desktop-universal-content': isDesktop, 'mobile-universal-content': !isDesktop}">
            <div class="modal-header-close">
				<i class="iconfont icon-icon_close" @click="handleCancel"></i>
			</div>
            <div class="universal-content-title">
                {{ $t(options.title) }}
            </div>
            <div class="universal-content-sub_title">
                {{ $t(options.subTitle) }}
            </div>
            <div class="universal-content-button">
                <div class="universal-content-button-item_confirm btn btn-confirm" @click="handleConfirm">
                    {{ $t(options.btn2) }}
                </div>
                <div class="universal-content-button-item_cancel btn btn-cancel" @click="handleCancel">
                    {{ $t(options.btn1) }}
                </div>
            </div>
        </div>
    </n-dialog>
</template>

<script setup lang="ts">
import NDialog from '~/components/NDialog/index.vue'
const viewport = useViewport()
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
const visible = ref(false)
const options = ref({title: '', subTitle: '', btn1: '', btn2: ''})
const emit = defineEmits(['onCancel', 'onConfirm']);

const handleCancel = ()=>{
    console.log('取消')
    visible.value = false
    emit('onCancel')
}

const handleConfirm = ()=>{
    console.log('确认')
    visible.value = false
    emit('onConfirm')
}

const open = (object: {title: string, subTitle: string, btn1: string, btn2: string})=>{
    visible.value = true
    options.value = object
}

onMounted(()=>{
})

defineExpose({
    open
})
</script>

<style lang="scss" scoped>
@use './index.scss' as *;
@use './mobile.scss' as *;
</style>